import classnames from 'classnames';
import { type FunctionComponent, type MouseEvent } from 'react';

import { Button } from '@/core/tamagoshi/Button/Button';
import { AddShoppingCart } from '@/core/tamagoshi/icons/AddShoppingCart';

import styles from './AddToCartButton.module.scss';

export interface AddToCartButtonProps {
  className?: string;
  disabledMobileIcon?: boolean;
  onClick?(event: MouseEvent): void;
  text: string;
  theme: 'default' | 'pro';
  variant?: 'primary' | 'secondary' | 'tertiary';
}

export const AddToCartButton: FunctionComponent<AddToCartButtonProps> = ({
  className,
  disabledMobileIcon = false,
  onClick,
  text,
  theme,
  variant = 'primary',
}) => {
  const rootClassnames = classnames(
    styles.root,
    { [styles.disabledMobileIcon]: disabledMobileIcon },
    className,
  );
  const iconClassnames = classnames(styles.iconButton);
  return (
    <Button
      className={rootClassnames}
      onClick={onClick}
      icon={<AddShoppingCart className={iconClassnames} />}
      theme={theme}
      type="button"
      variant={variant}
      wordWrap
    >
      <span className={styles.text}>{text}</span>
    </Button>
  );
};

AddToCartButton.displayName = 'AddToCartButton';
